import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable, Subject } from 'rxjs/Rx';
import { Setting } from '../setting';


@Injectable()
export class AppConfig {

    private paths: Array<Setting> = [];
    private config: Array<Setting> = [];
    private env: Object = null;

    private subject = new Subject<boolean>();
    public initialized = this.subject.asObservable();

    constructor(private http: Http) { }

    public getPresentationConfigs() {
        return this.config.filter(x => x.key.toLowerCase().endsWith("config"));
    }

    public get(key: string) {
        let setting = this.config.filter(x => x.key.toLowerCase() == key.toLowerCase());

        return setting.length > 0 ? setting[0].value : null;
    }

    public getEnv(key: any) {
        return this.env[key];
    }

    public addNavigationItems(applicationName: string, paths: Array<any>) {
        for (let path of paths) {
            if (this.paths.filter(x => x.value.name == path.name).length == 0) {
                this.paths.push(new Setting(applicationName, { name: path.name, route: path.route }));
            }
        }
    }

    public fetchNavigationItems(applicationName: string) {
        return this.paths.filter(x => x.key === applicationName).map(x => new Setting(x.value.name, x.value.route));
    }

    public initialize(settings: Array<Setting>, env: string) {
        this.config = this.config.concat(settings);
        this.env = env;
        this.subject.next(true);
    }
}